import { graphql, PageProps, useStaticQuery } from 'gatsby';
import React from 'react';
import { DynamicPageData, DynamicPageRenderer } from 'src/templates/dynamicPage';

const DynamicPage = (props: PageProps): JSX.Element => {
  const data: DynamicPageData = useStaticQuery(graphql`{
    contentfulPageDynamic(slug: { eq: "builder-mn" }) {
      seoTitle
      seoDescription
      theme
      canonicalTagSlug
      seoImage {
        file {
          url
        }
      }
      title
      contentfulchildren {
        ...SectionDynamicContent
        ...SectionColumnDynamicContent
      }
    }
  }
  `)

  return (
    <DynamicPageRenderer {...props} data={data} />
  )
}

export default DynamicPage;
